import { generatePath } from "react-router-dom";
import { PREVIEW_TASK_GRID_PATH } from "view/routes";
import { useCallback } from "react";

/**
 * Opens the standalone grid-preview window for one response version. The page
 * loads the answer itself from the public `task/grid-preview/:responseId`
 * endpoint (session-aware — a logged-in viewer with show access sees any
 * version; the same URL is what PDFs bake for anonymous readers). This replaced
 * the old `window.postMessage` hand-off so every entry point uses one mechanism.
 */
const useOpenGrid = (showId: string) =>
  useCallback(
    (responseId: string | undefined) => {
      if (!showId || !responseId) return;
      const path = generatePath(PREVIEW_TASK_GRID_PATH, { showId });
      const params = new URLSearchParams({ responseId });
      window.open(`${path}?${params}`, "_blank");
    },
    [showId]
  );

export default useOpenGrid;
